// TODO แก้iconและชื่อ
// NOTE feathericon https://vue-feather-icons.egoist.sh/
// NOTE materialIcon https://material.io/resources/icons/?style=baseline
export default [
  {
    url: "/dashboard",
    name: "Dashboard",
    slug: "home",
    iconPack: "material-icons",
    icon: "dashboard",
    iconColor: "#eca253",
  },
  {
    url: "/task",
    name: "Task",
    slug: "second",
    icon: "tasks",
    iconColor: "#03a9f3",
  },
  {
    url: "/invoice",
    name: "ใบแจ้งหนี้",
    slug: "third",
    icon: "file-invoice-dollar",
    iconColor: "#FEF487",
  },
  {
    // url: "/third",
    url: "/receipt",
    name: "ใบเสร็จรับเงิน",
    slug: "fourth",
    icon: "receipt",
    iconColor: "#47c360",
  },
  {
    // url: "/third",
    url: "/managemember",
    name: "จัดการสมาชิก",
    slug: "fifth",
    icon: "users",
    iconColor: "#f2a655",
  },
  {
    url: "/manageadmin",
    name: "จัดการแอดมิน",
    slug: "sixth",
    submenu: [
      {
        url: "/manageadmin",
        name: "จัดการแอดมิน",
        slug: "sixth",
        icon: "users",
      },
      {
        url: "/adminsetting",
        name: "ตั้งค่าแอดมิน",
        slug: "fourth",
        icon: "cog",
      },
    ],
    icon: "users-cog",
    iconColor: "#47c360",
  },
  {
    url: "/accounting",
    name: "การตั้งค่า",
    slug: "seventh",
    submenu: [
      {
        url: "/accounting",
        name: "ผู้รับเงิน",
        slug: "seventh",
        icon: "list-ul",
      },
      {
        url: "/bankpayment",
        name: "บัญชีธนาคาร",
        slug: "eighth",
        icon: "university",
      },
      {
        url: "/profile",
        name: "โปรไฟล์",
        slug: "ninth",
        icon: "user-circle",
      },
    ],
    icon: "cog",
    iconColor: "#03a9f3",
  },
  {
    url: "/userfile",
    name: "All Files",
    slug: "hundred",
    icon: "folder",
    iconColor: "#03a9f3",
  },
  {
    url: "/logout",
    name: "ออกจากระบบ",
    slug: "hundred",
    iconPack: "material-icons",
    icon: "logout",
    iconColor: "#ff4a3d",
  },
];
